<div class="container container-padding">

    <h1 class="page-header">{{'CLIENTS.HEADER' | translate}}</h1>

    <app-alert alertType="info" *ngIf="flag?.active === false">
        {{ 'SCHEDULE.APPLICATION_IS_NOT_ACTIVE' | translate }}
    </app-alert>

    <app-party-form [title]="'LABEL.POLICYHOLDER' | translate"
                    prefix="policyholder"
                    [party]="request.policyholder">
    </app-party-form>

    <div class="row form-row">
        <div class="col form-label-static">
            <mat-checkbox [(ngModel)]="request.policyholderIsInsuredPerson">
                {{ 'LABEL.INSURER_IS_INSURED' | translate }}
            </mat-checkbox>

            <app-errors [errorStateMatcher]="matchers.policyholderIsInsuredPerson"></app-errors>
        </div>
    </div>


    <div class="row form-row" *ngIf="matchers.insuredPersonList.errors.length > 0">
        <div class="col">
            <app-message-box [errorStateMatcher]="matchers.insuredPersonList"></app-message-box>
        </div>
    </div>

    <ng-container *ngFor="let insured of request.insuredPersonList; let index = index; let first = first">
        <ng-container *ngIf="!first">
            <div class="separator"></div>
            <hr>
        </ng-container>

        <app-party-form [title]="'LABEL.INSURED_NUMBER' | translate : {index: index + 1}"
                        [prefix]="'insuredPersonList[' + index + ']'"
                        (removeClicked)="remove(index)"
                        [hasRemoveInsured]="true"
                        [party]="insured">
        </app-party-form>
    </ng-container>


    <div *ngIf="request.insuredPersonList.length < 3">
        <button class="btn btn-link btn-slim"
                (click)="addInsured()">
            <i class="icon-add mr-2"></i> <span>{{ 'BUTTON.ADD_INSURED' | translate }}</span>
        </button>
    </div>

    <div class="row">
        <div class="col-4">
            <button class="btn btn-primary btn-block mt-4"
                    (click)="save()">
                {{ 'LABEL.GO_TO_CALCULATION' | translate }}
            </button>
        </div>

    </div>
</div>
